export default "__VITE_ASSET__BZz4GIqo__"